import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as $ from "jquery";
import * as _ from "underscore";
import { on, Options } from "../utils/decorators";

interface props {
  controller: any;
}

@Options({
  template: false,
  el: "body",
  ui: {
    backToTopWrapper: ".back_to_top_wrapper",
    whereToBuyPage: ".where-to-buy-page",
    whereToBuyDisclaimer: ".js-where-to-buy-disclaimer-overlay",
    continueBtn: ".js-continue-btn"
  }
})
export default class ViewController extends Marionette.View<Backbone.Model> {
  constructor() {
    super();
  }

  onRender() {
    this.scrolTopButton();
    this.addEventListeners();
  }

  addEventListeners() {
    this.ui.continueBtn.on(
      "click",
      function(event) {
        event.preventDefault();
        this.ui.whereToBuyDisclaimer.css("display", "none");
        this.ui.whereToBuyPage.prevObject.removeClass("is-overflow-hidden");
      }.bind(this)
    );
  }

  scrolTopButton() {
    $(".iframe-button").on("click", function(e) {
      e.preventDefault();
      $("html, body").animate(
        { scrollTop: $(".where-to-buy-page__iframe").offset().top },
        "300"
      );
    });
  }
}
